var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgExternalContent = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 21H3C1.34315 21 0 19.6569 0 18V3C0 1.34315 1.34315 0 3 0H21C22.6569 0 24 1.34315 24 3V7.5H22.5V3.0165C22.5004 2.61418 22.3408 2.22822 22.0563 1.94373C21.7718 1.65925 21.3858 1.4996 20.9835 1.5H3C2.17157 1.5 1.5 2.17157 1.5 3V18C1.5 18.8284 2.17157 19.5 3 19.5H10.5V21ZM4.5 6H19.5V4.5H4.5V6ZM16.5 12V10.5H24V18H22.5V13.0605L14.781 20.781L13.719 19.719L21.4395 12H16.5ZM19.5 9H4.5V7.5H19.5V9ZM4.5 12H13.5V10.5H4.5V12ZM4.5 15H13.5V13.5H4.5V15Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExternalContent);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/external-content.12f8b9e72ca00009f72f4f171209be8d.svg";